import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/shared/services/rest.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'src/app/shared/message.service';

@Component({
  selector: 'app-redefinir-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.css']
})
export class RedefinirSenhaComponent implements OnInit {
  form: FormGroup;
  login: string = null;
  secret_key: string = null;
  uuid: string = null;
  constructor(
    private route: ActivatedRoute,
    private rest: RestService,
    private router: Router,
    private session: SessionService,
    private formB: FormBuilder,
    private info: MessageService
  ) { }

  ngOnInit(): void {
    this.session.clear();
    this.form = this.formB.group({
      login: [null, [Validators.nullValidator]],
      senha: [null, [Validators.required]],
      senha2: [null, [Validators.required]]
    })
    this.route.params.subscribe((params: any) => {
      if (params['uuid']) {
        this.uuid = params['uuid'];
        this.rest.validaUUIDRecuperacaoSenha(params['uuid']).subscribe((data: any) => {
          if (data.status == 'success' && data.valido) {
            this.secret_key = data.secret_key;
            this.login = data.login;
            this.form.get("login").setValue(this.login)
          }
          else {
            this.info.showAlert("Acesso Negado");
            this.router.navigate(["/"]);
          }
        });
      }
    });
  }

  salvarNovaSenha() {
    let senha = this.form.get('senha').value;
    let senha2 = this.form.get('senha2').value;
    if (senha != senha2) {
      this.info.showAlert("As senhas não correspondem");
      return;
    }
    let postData = {
      "senhaHash": this.rest.getHash(this.login + '' + senha, this.secret_key),
      "uuid": this.uuid
    }
    this.rest.SalvarNovaSenha(postData).subscribe((data: any) => {
      if(data.status == "success"){
        this.info.showSuccess("Senha alterada com sucesso");
        this.router.navigate(["/"])
      }
    })
  }
}
